<template>
  <div class="customer-list">
    <CCard>
      <CCardHeader><strong>لیست مشتریان</strong></CCardHeader>
      <CCardBody>
        <ServerTable ref="table" url="/api/admin/user/get_customers" :fields="fields" :tabs="tabs"
                     search-placeholder="نام، موبایل یا ایمیل" empty-text="مشتری‌ای یافت نشد">
          <template #name="{item}"><td>{{ item.name || '—' }}<div class="small text-muted">{{ item.email }}</div></td></template>
          <template #mobile="{item}"><td dir="ltr" class="text-right">{{ item.mobile }}</td></template>
          <template #orders_total="{item}"><td>{{ get_currency(item.orders_total) }} <small class="text-muted">تومان</small></td></template>
          <template #created_at="{item}"><td class="text-muted">{{ get_date_time(item.created_at) }}</td></template>
          <template #last_login_at="{item}"><td class="text-muted">{{ item.last_login_at ? get_date_time(item.last_login_at) : '—' }}</td></template>
          <template #status="{item}"><td><span :class="['badge', item.status === 1 ? 'badge-success' : 'badge-danger']">{{ item.status === 1 ? 'فعال' : 'مسدود' }}</span></td></template>
          <template #operation="{item}">
            <td class="text-nowrap">
              <CButton color="primary" variant="outline" size="sm" @click="$router.push('/dashboard/orders/list/' + item.id)">سفارش‌ها ({{ item.orders_count }})</CButton>
              <CButton :color="item.status === 1 ? 'danger' : 'success'" variant="ghost" size="sm" :disabled="busy === item.id" @click="toggle(item)">
                {{ item.status === 1 ? 'مسدود کردن' : 'فعال کردن' }}</CButton>
            </td>
          </template>
        </ServerTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "@/api/http";
import ServerTable from "@/views/includes/ServerTable.vue";
import { confirmAsk, apiToast } from "@/utils/confirm";

export default {
  name: 'CustomerList',
  components: { ServerTable },
  data() {
    return {
      busy: 0,
      tabs: [{ value: '', label: 'همه' }, { value: 1, label: 'فعال' }, { value: 2, label: 'مسدود' }],
      fields: [
        { key: 'name', label: 'نام' },
        { key: 'mobile', label: 'موبایل' },
        { key: 'orders_count', label: 'سفارش‌ها' },
        { key: 'orders_total', label: 'جمع خرید' },
        { key: 'created_at', label: 'عضویت' },
        { key: 'last_login_at', label: 'آخرین ورود' },
        { key: 'status', label: 'وضعیت' },
        { key: 'operation', label: 'عملیات' },
      ],
    }
  },
  methods: {
    async toggle(item) {
      const status = item.status === 1 ? 2 : 1
      if (status === 2 && !(await confirmAsk(this, 'مشتری مسدود شود؟ امکان ورود به فروشگاه را نخواهد داشت.'))) return
      this.busy = item.id
      axios.post('/api/admin/user/set_customer_status', { id: item.id, status }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) this.$refs.table.patchRow(item.id, { status })
      }).catch((e) => console.log(e)).finally(() => { this.busy = 0 })
    },
  },
}
</script>
